import {
  IonButton,
  IonContent,
  IonFooter,
  IonHeader,
  IonIcon,
  IonItem,
  IonLabel,
  IonModal,
  IonPopover,
  IonSearchbar,
  IonTitle,
  IonToolbar,
} from "@ionic/react";
import React, { useEffect, useMemo, useRef, useState } from "react";
import {
  AdvertisingDetailsType,
  BhpThemeHeaderWithBack,
  BusinessDetailsType,
  BusinessHomePageSection,
  BusinessProductCategoryWithProducts,
} from "../pages/BussinessHomePage";
import { add, filter } from "ionicons/icons";
import {
  convertImgJsonToObj,
  getLogo,
  searchStringSuccess,
} from "../common/commonFunctions";
import "./styles/BhpShowAllPromoModal.css";
import "./styles/ImageRotateStyle.css";
import {
  API_SECURE_KEY,
  IDIGIZEN_BACKEND_URL,
  getFileThumbnailDB,
} from "../types/constants";
import ContentWithBackground from "../UI/ContentWithBackground";
import BhpAdBannerWrapper from "./BhpAdBannerWrapper";
import BhpTrendsSection from "./BhpTrendsSection";
import { AdvanceCustomizationType } from "../types/data_types";

const BhpShowAllPromoModal: React.FC<{
  logoImgData: string;
  open: boolean;
  onDismiss: () => void;
  theme: any;
  bussinessDetailsDB: BusinessDetailsType;
  advertisingBannerData: AdvertisingDetailsType[];
  logoImg: { fileName: string; rotation: number; imgCss: string };
  allShops: BusinessProductCategoryWithProducts[];
  bannerButtonClick: (url?: string) => void;
  expandAdImage: (filename: string[]) => void;
  customerDetails: {
    id: number;
    name: string;
    phone: number;
    email: string;
    address: string;
    couponCode?: string;
    merchantName?: string;
    couponDescription?: string;
  };
  editMode?: boolean;
  openTrendsExpand?: (id: string) => void;
  floating?: boolean;
  advanceCustomization: AdvanceCustomizationType;
  title?: string;
}> = (props) => {
  interface ShopAdCategoryCluster {
    domain: string;
    shopName: string;
    category: string;
    shopCategory: string;
    adCard: AdvertisingDetailsType[];
    iden: number[];
    logoImg: string;
  }

  // const modeTrends = useMemo(() => {
  //   if (
  //     props.advertisingBannerData.length &&
  //     props.advertisingBannerData[0].promoType === "TRENDS"
  //   )
  //     return true;
  //   else return false;
  // }, [props.advertisingBannerData]);
  const modeTrends = true;
  const [allAds, setAllAds] = useState<ShopAdCategoryCluster[]>([]);
  const [categories, setCategories] = useState<string[]>([]);
  const [selCat, setSelCat] = useState<string>("All");
  const filteredAds: ShopAdCategoryCluster[] = useMemo(() => {
    return allAds.filter(
      (el) => el.shopCategory === selCat || selCat === "All"
    );
  }, [allAds, selCat]);
  const [searchCat, setSearchCat] = useState<boolean>(false);
  const [searchCatStr, setSearchCatStr] = useState<string>("");
  const searchCatRef = useRef(null);

  const handleScroll = (val, isCentre = false) => {
    const element = document.getElementById(val);
    if (element) {
      element.scrollIntoView({
        behavior: "smooth",
        block: isCentre ? "center" : "start",
      });
    }
    console.log(" input clicked ", element);
  };

  // const enterAnimation = (baseEl: HTMLElement) => {
  //   const root = baseEl.shadowRoot;

  //   const backdropAnimation = createAnimation()
  //     .addElement(root?.querySelector("ion-backdrop")!)
  //     .fromTo("opacity", "0.01", "var(--backdrop-opacity)");

  //   const wrapperAnimation = createAnimation()
  //     .addElement(root?.querySelector(".modal-wrapper")!)
  //     .keyframes([
  //       { offset: 0, opacity: "0", transform: "scale(0)" },
  //       { offset: 1, opacity: "0.99", transform: "scale(1)" },
  //     ]);

  //   return createAnimation()
  //     .addElement(baseEl)
  //     .easing("ease-out")
  //     .duration(500)
  //     .addAnimation([backdropAnimation, wrapperAnimation]);
  // };

  useEffect(() => {
    if (
      props.open &&
      props.bussinessDetailsDB.isMarket &&
      props.allShops.length &&
      props.advertisingBannerData
    ) {
      const retVal: ShopAdCategoryCluster[] = [];

      for (const ad of props.advertisingBannerData) {
        const shopDomain = ad.shopDomain ? ad.shopDomain : "Offers";
        let shopEl: ShopAdCategoryCluster = retVal.find(
          (el) => el.domain === shopDomain
        );
        if (!shopEl) {
          shopEl = {
            adCard: [],
            category: !ad.shopDomain ? "Offer" : ad.category,
            domain: shopDomain,
            iden: [],
            logoImg: props.logoImg.fileName,
            shopName: !!ad.shopDomain ? ad.shopName : "Offer",
            shopCategory: !ad.shopDomain ? "Offer" : ad.shopCategory,
          };
          retVal.push(shopEl);
        }
        shopEl.adCard.push(ad);
      }
      let iden = 1;
      for (const el of retVal) {
        for (const item of el.adCard) {
          el.iden.push(iden++);
        }
      }

      const categoriesL: string[] = [];
      for (const el of retVal) {
        if (!categoriesL.includes(el.shopCategory)) {
          categoriesL.push(el.shopCategory);
        }
      }
      console.log("Set Ad data ", retVal);
      setAllAds(retVal);
      setCategories(
        categoriesL.filter((el) => {
          const catIdx = retVal.find((item) => item.shopCategory === el);
          return !!catIdx;
        })
      );
    } else {
      setAllAds([]);
    }
  }, [
    props.open,
    props.allShops,
    props.bussinessDetailsDB,
    props.advertisingBannerData,
  ]);

  const [searchShopPromo, setSearchShopPromo] = useState("");
  const baseUrl = `${IDIGIZEN_BACKEND_URL}/${getFileThumbnailDB}?percentage=40&Authorization=${API_SECURE_KEY}&`;
  return (
    <>
      <IonModal
        // enterAnimation={enterAnimation}
        // className={
        //   props?.floating || !modeTrends ? "bhp-show-poromo-shrink-size" : ""
        // }
        isOpen={props.open}
        onDidDismiss={() => {
          props.onDismiss();
          setSearchShopPromo("");
        }}
        initialBreakpoint={1}
        breakpoints={[0.5, 0.75, 1]}
      >
        <BhpThemeHeaderWithBack
          onBack={props.onDismiss}
          title={props?.title ? props.title : "All Offers & Events"}
        >
          {!modeTrends && props.bussinessDetailsDB.isMarket && (
            <>
              <div className="bhp-show-all-offer-cat-wrpr">
                <div className="bhp-show-all-offer-cat-search">
                  <div
                    className="bhp-show-all-offer-cat-search-button"
                    onClick={setSearchCat.bind(this, true)}
                  >
                    <IonIcon icon={filter} />{" "}
                    <span style={{ fontSize: "small" }}>Filter</span>
                  </div>
                </div>
                <div className="bhp-show-all-offer-cat-top">
                  <div
                    id="bhp-show-all-offer-cat-el-id-all"
                    className={`bhp-show-all-offer-cat-el ${
                      selCat === "All" ? "bhp-show-all-offer-cat-el-sel" : ""
                    }`}
                    onClick={setSelCat.bind(this, "All")}
                  >
                    All
                  </div>
                  {categories.map((el) => {
                    const sel = selCat === el;
                    return (
                      <div
                        id={`bhp-show-all-offer-cat-el-id-${el.replace(
                          / /g,
                          "-"
                        )}`}
                        className={`bhp-show-all-offer-cat-el ${
                          sel ? "bhp-show-all-offer-cat-el-sel" : ""
                        }`}
                        onClick={setSelCat.bind(this, el)}
                      >
                        {el}
                      </div>
                    );
                  })}
                </div>
              </div>
              <div style={{ background: "var(--ion-color-medium)" }}>
                <IonSearchbar
                  color={"light"}
                  value={searchShopPromo}
                  onIonChange={(e) => {
                    setSearchShopPromo(e.detail.value);
                  }}
                  placeholder="Search Shop for Offers"
                />
              </div>
            </>
          )}
        </BhpThemeHeaderWithBack>
        <ContentWithBackground>
          {!props.advertisingBannerData.length && (
            <>
              <div className="bhp-no-ad-active">
                <div
                  style={{
                    height: "300px",
                    width: "300px",
                    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                  }}
                  className={props.logoImg.imgCss}
                >
                  <img
                    style={{
                      height: "100%",
                      width: "100%",
                      objectFit: "cover",
                    }}
                    src={`${
                      props.logoImg.fileName
                        ? `https://api.newprod.idigizen.com/getThumbnail?fileName=${props.logoImg.fileName}&percentage=100&Authorization=8BEYKFmSROr0iUV36SjUUOu38ZDgifivsFU2SzbUKNTXUQY0b42LkveyQ0Y7t4BtypcMnvrjLJL4o5SUoaE9siUrfS3wSUi2&`
                        : getLogo()
                    }`}
                    alt=""
                    loading="lazy"
                  />
                </div>
                <h1
                  style={{
                    textAlign: "center",
                    color: "var(--ion-color-dark)",
                    fontSize: "3rem",
                    fontWeight: "bolder",
                  }}
                >
                  <div>No Offers Or Promos Active</div>
                </h1>
              </div>
            </>
          )}
          <div style={{ marginTop: "5px" }}></div>
          {!modeTrends &&
            !filteredAds.length &&
            props.bussinessDetailsDB.isMarket && (
              <div
                style={{
                  marginTop: "10px",
                  padding: "10px",
                  background: "white",
                  textAlign: "center",
                }}
              >
                No Offers Found!
              </div>
            )}
          {!modeTrends &&
            filteredAds.map((el, shopIdx) => {
              const value = convertImgJsonToObj(el.logoImg);
              const imgUrl = `${baseUrl}fileName=${value.fileName}&`;
              const filteredAd = el.adCard.filter((item) =>
                searchStringSuccess(searchShopPromo, item.shopName)
              );
              if (!filteredAd.length) return <></>;
              return (
                <BusinessHomePageSection
                  subHeaderText={el.shopName}
                  enableSubheaderStickyScroll={true}
                  headingLine={true}
                  subHeaderButtons={[
                    {
                      color: "dark",
                      onClick: () => {},
                      name: `${filteredAd.length}`,
                      fill: "solid",
                    },
                  ]}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      flexDirection: "column",
                      alignItems: "center",
                    }}
                  >
                    {filteredAd.map((item, idx) => {
                      const num = idx + shopIdx;
                      return (
                        <>
                          <div style={{ height: "10px" }}></div>
                          <BhpAdBannerWrapper
                            contextIsShop={!props.bussinessDetailsDB.isMarket}
                            idx={num}
                            adData={item}
                            logoImgData={props.logoImgData}
                            domainName={props.bussinessDetailsDB.domainName}
                            marketDomain={
                              !props.bussinessDetailsDB.isMarket
                                ? props.bussinessDetailsDB.marketDomain
                                : ""
                            }
                            marketName={
                              !props.bussinessDetailsDB.isMarket
                                ? props.bussinessDetailsDB.marketName
                                : props.bussinessDetailsDB.name
                            }
                            marketType={props.bussinessDetailsDB.marketType}
                            pageId={props.bussinessDetailsDB.id}
                            pageSection={"AD_ALL"}
                            recordUserInteraction={true}
                          />
                        </>
                      );
                    })}
                  </div>
                </BusinessHomePageSection>
              );
            })}
          {!modeTrends &&
            !props.bussinessDetailsDB.isMarket &&
            props.advertisingBannerData.map((el, idx) => {
              return (
                <>
                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    <BhpAdBannerWrapper
                      contextIsShop={!props.bussinessDetailsDB.isMarket}
                      adData={el}
                      idx={idx}
                      logoImgData={props.logoImgData}
                      domainName={props.bussinessDetailsDB.domainName}
                      marketDomain={
                        !props.bussinessDetailsDB.isMarket
                          ? props.bussinessDetailsDB.marketDomain
                          : ""
                      }
                      marketName={
                        !props.bussinessDetailsDB.isMarket
                          ? props.bussinessDetailsDB.marketName
                          : props.bussinessDetailsDB.name
                      }
                      marketType={props.bussinessDetailsDB.marketType}
                      pageId={props.bussinessDetailsDB.id}
                      pageSection={"AD_ALL"}
                      recordUserInteraction={true}
                    />
                  </div>
                  {/* <BusinessHomePageBanner
                    disablePrimaryButton={!props.bussinessDetailsDB.isMarket}
                    logoImgData={props.logoImgData}
                    customerDetails={props.customerDetails}
                    disableSecondaryButton={true}
                    bussinessDetailsDB={props.bussinessDetailsDB}
                    onClick={props.bannerButtonClick}
                    advertising={el}
                    fixBgIdx={idx}
                    expandAdImage={() => {
                      props.expandAdImage(
                        el.saleImg.map((item) => item.imgName)
                      );
                    }}
                  /> */}
                  <div style={{ height: "15px" }}></div>
                </>
              );
            })}
          {modeTrends && (
            <div>
              <BhpTrendsSection
                bussinessDetailsDB={props.bussinessDetailsDB}
                openTrendsExpand={props.openTrendsExpand}
                adData={props.advertisingBannerData}
                gridMode={true}
                editMode={props.editMode}
                pageId={props.bussinessDetailsDB.id}
                pageSection="TREND_ALL"
                recordUserInteraction={true}
                advanceCustomization={props.advanceCustomization}
              />
              {!!props?.editMode && (
                <IonButton size="small" fill="clear" color={"tertiary"}>
                  <IonIcon icon={add} slot="start" />
                  Add What's Trending At Your Shop
                </IonButton>
              )}
            </div>
          )}
        </ContentWithBackground>
        <IonFooter>
          <div style={{ padding: "5px" }}>
            <IonButton
              fill="clear"
              expand="block"
              color={"danger"}
              onClick={props.onDismiss}
            >
              Close
            </IonButton>
          </div>
        </IonFooter>
      </IonModal>
      <IonPopover
        isOpen={searchCat}
        onDidDismiss={() => {
          setSearchCat(false);
          setSearchCatStr("");
        }}
        ref={searchCatRef}
        className="bhp-all-offer-cat-sel-popover"
      >
        <IonHeader>
          <IonToolbar>
            <IonTitle>Category Search</IonTitle>
            {/* <IonButtons slot="end">
              <IonButton
                color={"danger"}
                onClick={setSearchCat.bind(this, false)}
              >
                <IonIcon icon={close} slot="start" /> Close
              </IonButton>
            </IonButtons> */}
          </IonToolbar>
          <div style={{ background: "rgba(0,0,0,0.2)" }}>
            <IonSearchbar
              color={"light"}
              value={searchCatStr}
              onIonChange={(e) => {
                setSearchCatStr(e.detail.value);
              }}
            />
          </div>
        </IonHeader>
        <IonContent>
          {!searchCatStr && (
            <IonItem
              onClick={() => {
                setSelCat("All");
                handleScroll(`bhp-show-all-offer-cat-el-id-all`);
                searchCatRef.current.dismiss();
              }}
            >
              <IonLabel>All</IonLabel>
            </IonItem>
          )}
          {categories
            .filter((el) => searchStringSuccess(searchCatStr, el))
            .map((el) => {
              return (
                <IonItem
                  onClick={() => {
                    setSelCat(el);
                    handleScroll(
                      `bhp-show-all-offer-cat-el-id-${el.replace(/ /g, "-")}`
                    );
                    searchCatRef.current.dismiss();
                  }}
                >
                  <IonLabel>{el}</IonLabel>
                </IonItem>
              );
            })}
        </IonContent>
        <IonFooter>
          <IonButton
            expand="block"
            color={"danger"}
            onClick={setSearchCat.bind(this, false)}
          >
            Close
          </IonButton>
        </IonFooter>
      </IonPopover>
    </>
  );
};

export default BhpShowAllPromoModal;
